import { useEffect } from 'react';
import { ensureDecision, hasAuthToken, markSettled, redirectToFallback } from './index';

// Single routing authority in EVERY environment (the Vite dev middleware that used to do
// this in local dev has been removed). On every full document load — typed URL, hard
// reload, new tab, external link in — this redirects an unmigrated route to the legacy
// host, but only after the first flag poll has completed so migrated routes are not
// mis-bounced during the init window.
//
// Pre-login (no JWT) the flag endpoint can't be reached, so we render in place and never
// redirect — pre-login pages stay on the shell.
export function useServerFallbackGuard(): void {
  useEffect(() => {
    // No token → not logged in → never redirect (render in place).
    if (!hasAuthToken()) return;

    let cancelled = false;

    // ensureDecision loads the toggles on demand (fetching now if a cold cache means they
    // were never fetched — e.g. a hard load of a migrated route right after login) before
    // deciding, with a fail-toward-legacy timeout. No manual readiness polling needed.
    const { pathname, search, hash } = window.location;
    void ensureDecision(pathname).then((verdict) => {
      if (cancelled) return;
      if (verdict === 'shell') {
        markSettled();
      } else {
        redirectToFallback(pathname, search, hash);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);
}
